export function formatEventPayload(rawDetails: unknown): string | null {
  if (rawDetails == null || rawDetails === '') return null;
  if (typeof rawDetails !== 'string') return JSON.stringify(rawDetails, null, 2);
  try {
    return JSON.stringify(JSON.parse(rawDetails), null, 2);
  } catch {
    return rawDetails;
  }
}

const MAX_WEBHOOK_IMAGE_DATA_URI_LENGTH = 262144;
const WEBHOOK_IMAGE_TYPES = new Set(['image/png', 'image/jpeg', 'image/gif', 'image/webp']);

export interface WebhookImageArtifact {
  artifactName: string;
  contentType: string;
  dataUri: string;
  downloadFileName: string;
}

export function getWebhookImageArtifact(eventType: unknown, rawDetails: unknown): WebhookImageArtifact | null {
  if (String(eventType || '').toLowerCase() !== 'webhookresponseartifactpersisted') return null;

  let details: any;
  try {
    details = typeof rawDetails === 'string' ? JSON.parse(rawDetails) : rawDetails;
  } catch {
    return null;
  }

  const data = details?.schemaVersion === 'bl029.artifact.v1' ? details.data : null;
  if (data?.artifactType !== 'Image' || !WEBHOOK_IMAGE_TYPES.has(data.contentType)) return null;

  const match = typeof data.value === 'string'
    ? data.value.match(/^data:(image\/(?:png|jpeg|gif|webp));base64,([A-Za-z0-9+/]+={0,2})$/i)
    : null;
  if (!match || data.value.length > MAX_WEBHOOK_IMAGE_DATA_URI_LENGTH ||
      match[1].toLowerCase() !== data.contentType.toLowerCase() || match[2].length % 4 !== 0) return null;

  try {
    if (atob(match[2]).length === 0) return null;
  } catch {
    return null;
  }

  const name = typeof data.artifactName === 'string' ? data.artifactName.trim() : '';
  const safeName = name.replace(/[^a-z0-9_-]+/gi, '-').replace(/^-+|-+$/g, '').slice(0, 80) || 'webhook-image';
  const extension = data.contentType.toLowerCase() === 'image/jpeg'
    ? 'jpg'
    : data.contentType.slice('image/'.length).toLowerCase();

  return {
    artifactName: name || 'Webhook image',
    contentType: data.contentType,
    dataUri: data.value,
    downloadFileName: `${safeName}.${extension}`,
  };
}